import React, { createContext, useContext, useState, useEffect } from "react";
import PropTypes from 'prop-types';
const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    isLoggedIn: false,
    token: null,
    role: null,
  });

  useEffect(() => {
    // Check local storage for saved authentication data
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("userRole");

    if (token && role) {
      setAuth({
        isLoggedIn: true,
        token,
        role,
      });
    }
  }, []);

  const login = (authData) => {
    setAuth({
      isLoggedIn: true,
      token: authData.token,
      role: authData.role,
    });
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userRole");
    setAuth({
      isLoggedIn: false,
      token: null,
      role: null,
    });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};


export const useAuth = () => useContext(AuthContext);
